import React from 'react';

// Tiny markdown renderer for project progress digests.
// Supports: ## / ### headings, - bullets, **bold**, plain paragraphs.
// Deliberately minimal — no HTML injection, everything rendered as React nodes.

const renderInline = (text) => {
  const parts = [];
  let rest = text;
  let key = 0;
  while (rest.length) {
    const m = rest.match(/\*\*(.+?)\*\*/);
    if (!m) { parts.push(rest); break; }
    if (m.index > 0) parts.push(rest.slice(0, m.index));
    parts.push(<strong key={'b' + key++}>{m[1]}</strong>);
    rest = rest.slice(m.index + m[0].length);
  }
  return parts;
};

export const renderMiniMarkdown = (text) => {
  if (!text) return null;
  const lines = String(text).split(/\r?\n/);
  const blocks = [];
  let bullets = [];
  let key = 0;

  const flushBullets = () => {
    if (bullets.length) {
      blocks.push(<ul key={'ul' + key++} className="mmd-list">{bullets}</ul>);
      bullets = [];
    }
  };

  for (const raw of lines) {
    const line = raw.trimEnd();
    if (!line.trim()) { flushBullets(); continue; }
    if (line.startsWith('### ')) {
      flushBullets();
      blocks.push(<h4 key={'h' + key++} className="mmd-h4">{renderInline(line.slice(4))}</h4>);
    } else if (line.startsWith('## ')) {
      flushBullets();
      blocks.push(<h3 key={'h' + key++} className="mmd-h3">{renderInline(line.slice(3))}</h3>);
    } else if (/^[-*] /.test(line.trim())) {
      bullets.push(<li key={'li' + key++}>{renderInline(line.trim().slice(2))}</li>);
    } else {
      flushBullets();
      blocks.push(<p key={'p' + key++} className="mmd-p">{renderInline(line)}</p>);
    }
  }
  flushBullets();
  return blocks;
};
